export default __webpack_public_path__ + "static/media/vidotop_img01.6f7cdfe8.png";